// extracted by mini-css-extract-plugin
module.exports =  {"button":"da51a739f7--button--V3g73","button--active":"da51a739f7--button--active--cziSj","label":"da51a739f7--label--w54KZ"};